import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from './apiClient';
import { setOrgLocale } from '@/modules/accounting/format';

/** The organisation's date format and time zone (NFR-011, docs §185): read once a session, handed to the date helpers. */
export function useOrgLocaleSync() {
  const { data } = useQuery({
    queryKey: ['locale'],
    queryFn: async () => (await apiClient.get<{ dateFormat: string; timeZone: string }>('/api/v1/locale')).data,
    staleTime: 60 * 60 * 1000,
  });
  useEffect(() => { if (data) setOrgLocale(data.dateFormat, data.timeZone); }, [data]);
}
